import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { OfferType } from '@occc-app/offerValidationService/types';
import { ZodValidationError } from '@occc/ui-forms';
import { pluralize } from '@occc-app/lib/strings';

import {
  BuyAndGetFormSchema,
  FuelRollbackFormSchema,
  ProductDiscountFormSchema,
  TransactionDiscountFormSchema,
  VarietyDiscountFormSchema,
} from './schemas';
import { ProductDiscountAwardType, PromotionConfigureFormValues, PromotionType } from './types';
import { promotionTypesSupportingTransactionFrequencyLimit } from './constants';

import { createRouteCreator } from '../CampaignComponents/utils';

export const routeCreator = createRouteCreator(OfferType.Promotion);

export const getIsSupportPreAuthConstraint = (promotionType: PromotionType | null | undefined) => {
  return promotionType === PromotionType.FuelRollback;
};

export const getIsTransactionLimitSupported = (promotionType: PromotionType | null | undefined) => {
  return Object.values(PromotionType).includes(promotionType as PromotionType);
};

export const getIsTransactionFrequencyLimitSupported = (
  promotionType: PromotionType | null | undefined,
): boolean => {
  return promotionTypesSupportingTransactionFrequencyLimit.includes(promotionType as PromotionType);
};

const validatorByPromotionType: Record<
  PromotionType,
  (value: unknown) => Promise<ZodValidationError>
> = {
  [PromotionType.TransactionDiscount]: makeValidate(TransactionDiscountFormSchema),
  [PromotionType.ProductDiscount]: makeValidate(ProductDiscountFormSchema),
  [PromotionType.BuyAndGet]: makeValidate(BuyAndGetFormSchema),
  [PromotionType.VarietyDiscount]: makeValidate(VarietyDiscountFormSchema),
  [PromotionType.FuelRollback]: makeValidate(FuelRollbackFormSchema),
};

export const validateConfiguration = async (values: PromotionConfigureFormValues) => {
  if (values.offerType == null) {
    return;
  }

  return validatorByPromotionType[values.offerType](values);
};

export const getProductDiscountAwardTypeButtons = (purchaseThreshold: number | undefined) => {
  const pluralizedLabel = `${pluralize(purchaseThreshold || 1, 'Free Item')}`;
  const freeItemsTitle = `${purchaseThreshold ? purchaseThreshold + ' ' : ''}${pluralizedLabel}`;

  return [
    {
      title: freeItemsTitle,
      value: ProductDiscountAwardType.Free,
    },
    { title: 'Discount', value: ProductDiscountAwardType.Discount },
    { title: 'Override', value: ProductDiscountAwardType.PriceOverride },
  ];
};
